const fuseGlobalOpts = {
    shouldSort: true,
    threshold: 0.6,
    location: 0,
    distance: 100,
    maxPatternLength: 32,
    minMatchCharLength: 1
}

export default fuseGlobalOpts


// WEBPACK FOOTER //
// ./src/utils/fuse-global-options.js